// Scrolls CTA buttons marked with [data-pdp-scroll-to-buy] to the product form (bundles / add to cart).
(function () {
  if (window.__pdpScrollToBuyInit) return;
  window.__pdpScrollToBuyInit = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pdp-scroll-to-buy]');
    if (!trigger) return;

    var target = document.querySelector('bundle-picker, .product-form__buttons, product-form');
    if (!target) return;

    event.preventDefault();
    var rect = target.getBoundingClientRect();
    var top = rect.top + window.pageYOffset + rect.height / 2 - window.innerHeight / 2;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  });
})();
